import FooterPartenerCommun from "../commun/FooterPartenerCommun";
import Header from "../commun/Header";
import ContactCard from "./ContactCard";

export default function Contact(){

    const contacts = [
        {
            continent: "European Group",
            name: "Ms . Yulia Lœva",
            num: {
                numero: "+49 (178) 14 94 276",
                more: "(whatsapp/call/signal)",
            },
            mails:[
                'loeva@trilateraleurope.org',
                'loeva@dgap.org',
            ],
        }
    ]

    return(
        <div className="dashboard">
            <Header back={true}/>
            <div className="container">
                <h1 className="text-center mt-5">Contact</h1>
                <div className="row mt-3 mb-5">
                    {
                        contacts.map((contact, index)=>{
                            return(
                                <div key={index} className="col col-12 p-3">
                                    <ContactCard contact={contact}/>
                                </div>
                            )
                        })
                    }
                    
                </div>
            </div>
            <FooterPartenerCommun/>
        </div>
    )
}